import React, { useEffect } from 'react';

import { useDispatch } from 'react-redux';

import { resetAllSteps } from 'actions/stages';
import FormHeader from 'components/FormHeader';
import { ProgressBarStatus } from 'enums/ProgressBarStatus';

const FORM_TITLE = 'Unfortunately, you do not qualify at this time for a loan based on your credit profile';

const NoOptions = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    return () => {
      dispatch(resetAllSteps());
    };
  });

  return (
    <>
      <FormHeader title={FORM_TITLE} percent={ProgressBarStatus.Failed} />
    </>
  );
};

export default NoOptions;
